<template>

    <form ref="escolaestagio-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-6">
                <label for="valorMaterialDidaticoSugerido">Valor Material Didático Sugerido</label>
                <input type="text" class="form-control" name="valorMaterialDidaticoSugerido" placeholder="ValorMaterialDidaticoSugerido" v-model="model.valorMaterialDidaticoSugerido" required />
            </div>
            <div class="form-group col-md-6">
                <label for="valorEstagioSugerido">Valor Estágio Sugerido</label>
                <input type="text" class="form-control" name="valorEstagioSugerido" placeholder="ValorEstagioSugerido" v-model="model.valorEstagioSugerido" required />
            </div>
            <div class="form-group col-md-6">
                <label for="valorHoraSugerido">Valor Hora Sugerido</label>
                <input type="text" class="form-control" name="valorHoraSugerido" placeholder="ValorHoraSugerido" v-model="model.valorHoraSugerido" required />
            </div>
            <div class="form-group col-md-6">
                <label for="valorMaterialDidatico">Valor Material Didático</label>
                <input type="text" class="form-control" name="valorMaterialDidatico" placeholder="ValorMaterialDidatico" v-model="model.valorMaterialDidatico" required />
            </div>
            <div class="form-group col-md-6">
                <label for="valorEstagio">Valor Estágio</label>
                <input type="text" class="form-control" name="valorEstagio" placeholder="ValorEstagio" v-model="model.valorEstagio" required />
            </div>
            <div class="form-group col-md-6">
                <label for="valorHora">Valor Hora</label>
                <input type="text" class="form-control" name="valorHora" placeholder="ValorHora" v-model="model.valorHora" required />
            </div>
            <div class="form-group col-md-4">
                <label for="valorEstagioRematricula">Valor Estágio Rematricula</label>
                <input type="text" class="form-control" name="valorEstagioRematricula" placeholder="ValorEstagioRematricula" v-model="model.valorEstagioRematricula" required />
            </div>
            <div class="form-group col-md-4">
                <label for="valorMaterialDidaticoRematricula">Valor M.D Rematrícula</label>
                <input type="text" class="form-control" name="valorMaterialDidaticoRematricula" placeholder="ValorMaterialDidaticoRematricula" v-model="model.valorMaterialDidaticoRematricula" required />
            </div>

            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="vendaLiberada" class="custom-control-input" v-model="model.vendaLiberada">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Venda Liberada?</span>
                </label>
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "escolaestagio-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({
            model: {},

            form: "escolaestagio-form-edit",

            resources: {
                edit: 'escolaestagio',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ escolaEstagioId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>